import React, { useState } from "react";
import { COLORS } from "../../Constants/AppColors.js";
import { useTranslation } from "react-i18next";
import "../../Translation/i18n";
import i18n from "i18next";
import APIs from "../../network/APIs.js";
import Singleton from "../../cache/Singleton";

function HomePage() {
  const { t } = useTranslation();

  const [innerWidthState, setInnerWidthState] = useState(window.innerWidth);
  const [innerHeightState, setInnerHeightState] = useState(window.innerHeight);
  const [directionState, setDirectionState] = useState("ltr");

  

  React.useEffect(() => {
    const getUserToken = () => {
      console.log("APIs -> getUserToken()");
      var raw = JSON.stringify({
        username: "app",
        password: "ZE9fkV5N9fC8QH9",
      });
  
      APIs.instance.getUserToken(raw).then(([statusCode, data]) => {
        if (statusCode === 200) {
          Singleton.instance.storedUserToken = data.token;
        }
      });
    };

    getUserToken();

    console.log("i18n.language: " + i18n.language);

    if (i18n.language.includes("en")) {
      setDirectionState("ltr");
    } else {
      setDirectionState("rtl");
    }

    console.log("i18n.language: " + directionState);

    function handleResize() {
      console.log("resized to: ", window.innerWidth, "x", window.innerHeight);
      setInnerWidthState(window.innerWidth);
      setInnerHeightState(window.innerHeight);
    }

    window.addEventListener("resize", handleResize);

    console.log("i18n.locale: " + i18n.language);
  }, []);

  return (
    <div
      dir={directionState}
      style={{
        backgroundImage: `url(${require("../../assets/home_bg.png")})`,
        width: "100%",
        height: innerHeightState - 100 + "px",
        backgroundSize: "cover",
        // flex: 1,
        // flexDirection: "row",
        display: "flex",
        // alignItems: "center",
      }}
    >
      <div
        style={{
          // height: innerHeightState - 80 + "px",
          width: innerWidthState / 1.5 + "px",

          display: "flex",
          flexDirection: "column",
          // alignItems: "center",
          justifyContent: "center",
          marginLeft: i18n.language.includes("en") ? 30 : 0,
          marginRight: i18n.language.includes("ar") ? 30 : 0,
        }}
      >
        <label
          style={{
            color: "#FFFFFF",
            fontSize: 70,
            textAlign: i18n.language.includes("en") ? "left" : "right",
            fontFamily: i18n.language.includes("en")
              ? "CI-Font-Title"
              : "CI-Font-Title-ar",
            marginBottom: -20,
          }}
        >
          {t("home_page_title_pt1")}
        </label>
        <label
          style={{
            color: "#FFFFFF",
            fontSize: 70,
            textAlign: i18n.language.includes("en") ? "left" : "right",
            fontFamily: i18n.language.includes("en")
              ? "CI-Font-Title"
              : "CI-Font-Title-ar",
            marginBottom: -20,
          }}
        >
          {t("home_page_title_pt2")}
        </label>
        <label
          style={{
            color: "#3EA6DE",
            fontSize: 70,
            textAlign: i18n.language.includes("en") ? "left" : "right",
            fontFamily: i18n.language.includes("en")
              ? "CI-Font-Title"
              : "CI-Font-Title-ar",
          }}
        >
          {t("home_page_title_pt3")}
        </label>
      </div>
      <div
        style={{
          backgroundImage: `url(${require("../../assets/home_arrow.png")})`,
          height: innerHeightState - 120 + "px",
          width: innerWidthState / 2 + "px",
          // height: "95%",
          // width: "80%",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          // position: 'absolute',
        }}
      >
        <div
          style={{
            height: innerHeightState - 100 + "px",
            width: 60 + "px",
          }}
        >
          <label
            style={{
              color: "#FFFFFF",
              fontSize: 25,
              width: 50,
              height: 50,
              textAlign: "center",
              position: "absolute",
              bottom: i18n.language.includes("en") ? 45 : 33,
              left: i18n.language.includes("ar") ? 10 : null,
              right: i18n.language.includes("en") ? 10 : null,
              fontFamily: i18n.language.includes("en")
                ? "CI-Font-Body-Text-ar"
                : "CI-Font-Body-Text",
            }}
          >
            {t("language")}
          </label>
          <button
            style={{
              borderWidth: 1,
              borderColor: "#ffffff",
              alignItems: "center",
              justifyContent: "center",
              width: 50,
              height: 50,
              backgroundColor: "#ffffff01",
              borderRadius: 50,
              position: "absolute",
              bottom: 40,
              left: i18n.language.includes("ar") ? 10 : null,
              right: i18n.language.includes("en") ? 10 : null,
            }}
            onClick={() => {
              localStorage.setItem(
                "lang",
                i18n.language.includes("en") ? "ar" : "en"
              );
              const lang = localStorage.getItem("lang");
              i18n.changeLanguage(lang);
            }}
          ></button>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
